import Vue from 'vue'

import('../css/style.css')

import VueMask from 'v-mask'
Vue.use(VueMask)

import vClickOutside from 'v-click-outside'
Vue.use(vClickOutside)

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)

import router from './router'
import Header from './components/Header'
import Footer from './components/Footer'
import App from './App'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(Header),
}).$mount('#header')

new Vue({
  render: h => h(Footer),
}).$mount('#footer')

new Vue({
  router,
  render: h => h(App),
}).$mount('#section')
